import React from 'react';
import { Box, Typography } from '@mui/material';

function PatientView() {
  return (
    <Box 
      display="flex" 
      justifyContent="center" 
      alignItems="center" 
      height="100vh"
      style={{ backgroundColor: '#3B3B3D', color: 'white' }}
    >
      <Typography variant="h2">Under Maintenance</Typography>
    </Box>
  );
}

export default PatientView;
